<template>
  <div v-show="!loading">
    <div
      v-if="!loading"
      class="text-center"
    >
      <h3 v-text="title || membershipFee.attributes.title" />
      <p
        v-if="description"
        v-text="`${description} ${feeDescription}`"
      />
      <p
        v-else
        v-text="feeDescription"
      />
    </div>
    <div>
      <p
        v-if="form.errors.hasGenericError"
        class="border-2 border-red p-2 text-center text-red"
        v-text="form.errors.message"
      />
      <div class="field__label flex items-center justify-between">
        <label
          for="name_on_card"
          v-text="'Name On Card'"
        />
        <ErrorMessage :error="form.errors.get('name_on_car')" />
      </div>
      <input
        id="name_on_card"
        v-model="paymentMethod.billing_details.name"
        :class="{ 'error': form.errors.has('name_on_card') }"
        placeholder="Jane Doe"
        type="text"
        name="name_on_card"
      >
      <div class="field__label flex items-center justify-between">
        <label v-text="'Credit Card Information'" />
      </div>
      <div
        ref="card"
        class="sm:w-1/2"
      />
      <div
        v-if="isAccessRequest"
        class="mt-2 help-block"
      >
        <small
          class="help-text text-grey-darkest"
          v-text="'You will not be charged until an organization admin approves your access request.'"
        />
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
import { mapActions, mapState } from 'vuex'
import stripeMixin from 'Payments/Resources/assets/js/mixins/stripeMixin'
import Form from 'Base/Resources/assets/js/plugins/Form'
import ErrorMessage from 'FormBuilder/Resources/assets/js/components/inputs/ErrorMessage'

export default {
  name: 'MembershipFeePaymentForm',
  components: {
    ErrorMessage,
  },
  mixins: [stripeMixin],
  props: {
    runConfirmCardSetup: {
      type: Boolean,
      required: true,
    },
    isAccessRequest: {
      type: Boolean,
      required: false,
      default: false,
    },
    title: {
      type: [String, Boolean],
      required: false,
      default: false,
    },
    description: {
      type: [String, Boolean],
      required: false,
      default: false,
    },
  },
  data() {
    return {
      loading: true,
      paymentMethod: {
        card: null,
        billing_details: {
          name: null,
        },
      },
      form: new Form,
    }
  },
  computed: {
    ...mapState({
      membershipFee: state => state.payments.membershipFee,
      setupIntent: state => state.payments.setupIntent,
    }),
    feeDescription() {
      return `A fee of $${this.membershipFee.attributes.amount} will be charged ${this.membershipFee.attributes.payment_interval.toLowerCase()}. `
    },
  },
  watch: {
    runConfirmCardSetup(newValue, oldValue) {
      if (!oldValue && newValue) {
        this.confirmCardSetup()
      }
    },
    loading(newValue) {
      if (!newValue) {
        this.$emit('loaded')
      }
    },
  },
  mounted() {
    const vm = this
    const elements = this.stripe.elements()
    const style = {
      classes: {
        base: 'field',
      },
    }

    this.paymentMethod.card = elements.create('card', style)

    this.paymentMethod.card.mount(this.$refs.card)

    this.paymentsGetMembershipFee().then((result) => {
      vm.paymentsCreateSetupIntent().then((result) => {
        this.loading = false
      })
    })
  },
  methods: {
    ...mapActions([
      'paymentsGetMembershipFee',
      'paymentsCreateSetupIntent',
    ]),
    confirmCardSetup() {
      const vm = this

      vm.form.errors.clear()

      vm.form.errors.hasGenericError = false

      this.stripe.confirmCardSetup(
        this.setupIntent.client_secret,
        {
          payment_method: this.paymentMethod,
        }
      ).then((result) => {
        if (result.error) {
          vm.form.errors.hasGenericError = true
          vm.form.errors.message = result.error.message

          vm.$emit('cardSetupError', result)
        } else {
          vm.$emit('cardSetupConfirmed', result)
        }
      })
    },
  },
}
</script>

<style scoped>
.field {
  width: 100%;
  border-radius: .25rem;
  padding-left: .5rem;
  padding-right: .5rem;
  padding-top: .75rem;
  padding-bottom: .75rem;
  margin-bottom: 1.5rem;
  font-size: .875rem;
  border-width: 1px;
  border-color: #afb2b3
}
</style>
